import { render, staticRenderFns } from "./PortalFooter.vue?vue&type=template&id=8c4ee684&"
import script from "./PortalFooter.vue?vue&type=script&lang=js&"
export * from "./PortalFooter.vue?vue&type=script&lang=js&"
import style0 from "./PortalFooter.vue?vue&type=style&index=0&id=8c4ee684&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports